<template>
  <div class="avatar cursor-pointer shadow" :class="[radius, size]">
    <template v-if="session?.formatted_profile_image?.uri">
      <img
        :src="session?.formatted_profile_image?.uri"
        class="avatar-img"
        :class="radius"
      />
    </template>
    <template v-else>
      <img :src="placeholder" class="avatar-img" :class="radius" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";

withDefaults(
  defineProps<{
    radius?: string;
    size?: string;
  }>(),
  {
    radius: "rounded-4",
    size: "avatar-xxl",
  },
);

const { session } = storeToRefs(useSessionStore());

const placeholder = computed(() =>
  session.value?.gender === "female"
    ? require("@/assets/img/avatars/1.png")
    : require("@/assets/img/avatars/2.png"),
);
</script>
